import { graphql } from '../../../gql';

export const REVOKE_VOUCH_MUTATION = graphql(`
  mutation revokeVouch($vouchId: ID!) {
    revokeVouch(vouchId: $vouchId) {
      vouchId
      revokedAt
    }
  }
`);
